module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/agent-valuation-5caa596f9d3ac375f63660e157f6a6ef.svg";